import { observer } from 'mobx-react-lite';
import DropZone from './DropZone';
import type { DropZoneCombinedProps } from './types';

export type { DropZoneCombinedProps };
export default observer(DropZone);
